import React from "react";

import { type VariantProps } from "class-variance-authority";

import { Badge } from "@/components/flowbite/badge/badge";
import { TableCell } from "@/components/flowbite/table/table-cell";
import { TableHead } from "@/components/flowbite/table/table-head";
import { TableRow } from "@/components/flowbite/table/table-row";
import Typography from "@/components/flowbite/typography/typography";
import { cn } from "@/shared/helpers/cn.helper";

import { BASIC_INFO_ROW_CELL_BORDER_CLASS } from "./basic-information-table-row-border";

export interface StatusBadgeItem {
  value: string;
  variant?: VariantProps<typeof Badge>["variant"];
}

interface BasicInformationTableBadgesRowProps {
  head: string;
  badges: StatusBadgeItem[];
}

export const BasicInformationTableBadgesRow: React.FC<BasicInformationTableBadgesRowProps> = ({
  head,
  badges,
}) => {
  return (
    <TableRow>
      <TableHead
        className={cn(
          "m-0 h-auto min-h-[50px] w-[140px] min-w-[100px] whitespace-normal break-words p-0",
          BASIC_INFO_ROW_CELL_BORDER_CLASS,
        )}
      >
        <Typography.TableTitleXS colorShade={300}>
          {head}
        </Typography.TableTitleXS>
      </TableHead>
      <TableCell
        className={cn(
          "m-0 min-h-[50px] whitespace-normal text-wrap break-words p-0",
          BASIC_INFO_ROW_CELL_BORDER_CLASS,
        )}
      >
        <div className="flex flex-wrap gap-2 py-2">
          {badges.map((badge) => (
            <Badge
              key={badge.value}
              typography="bodyMRegular"
              variant={badge.variant ?? "default"}
            >
              {badge.value}
            </Badge>
          ))}
        </div>
      </TableCell>
    </TableRow>
  );
};
